import { render, staticRenderFns } from "./QualityLabel.vue?vue&type=template&id=89676172&scoped=true"
import script from "./QualityLabel.vue?vue&type=script&lang=js"
export * from "./QualityLabel.vue?vue&type=script&lang=js"
import style0 from "./QualityLabel.vue?vue&type=style&index=0&id=89676172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89676172",
  null
  
)

export default component.exports